import { FC, HTMLAttributes } from "react";
import clsx from "clsx";

import TextCard, { ITextCard } from "@/components/cards/TextCard";

// --------------------------------------------------------------------------------------------

export type ITwoColumnTextSectionProps = HTMLAttributes<HTMLElement> & {
  cards?: ITextCard[];
  cardVariant?: "light_primary" | "primary" | "secondary" | "white";
};

const TwoColumnTextSection: FC<ITwoColumnTextSectionProps> = (props) => {
  const { cards, cardVariant, className, ...other } = props;

  return (
    <section
      className={clsx("container mx-auto pb-5 lg:pb-8 xl:pb-[50px]", className)}
      {...other}
    >
      {cards && cards.length > 0 && (
        <div className="grid gap-5 md:grid-cols-2 lg:gap-8">
          {cards.map((card, idx) => (
            <TextCard
              key={idx}
              className="p-6 md:p-8 lg:p-12"
              heading={card.heading}
              description={card.description}
              headingClass="mb-5 inline-block lg:mb-8"
              descriptionClass="break-words"
              variant={cardVariant}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default TwoColumnTextSection;
